import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import ismail from './Ismail nasr.jpeg';
import ameer from './Ameer elgelany.jpeg';
import hady from './hady.jpeg';
import mazaaq from './boshra.jpeg';
import hind from './hind.jpg';

export default function ClientsReviews() {
  const reviews = [
    {
      id: 1,
      name: "Ismail Nasr",
      company: "CEO:Startup Packing",
      qualityCode: "\u2b50\u2b50\u2b50\u2b50\u2b50",
      ownerReview:
        "Everything I asked for was done to the highest standard, supervised by Engineer Mohand himself.",
      image: ismail,
    },
    {
      id: 2,
      name: "Ameer Elgelany",
      company: "Packing Pro",
      qualityCode: "\u2b50\u2b50\u2b50\u2b50\u2b50",
      ownerReview:
        "Our marketing campaign achieved great results, showcasing the team's excellent work.",
      image: ameer,
    },
    {
      id: 3,
      name: "Hady Ramadan",
      company: "Owner: Mr supply",
      qualityCode: "\u2b50\u2b50\u2b50\u2b50\u2b50",
      ownerReview:
        "Their designs were stunning and perfectly captured our brand identity. Highly recommended.",
      image: hady,
    },
    {
      id: 4,
      name: "Boshra ELsayed",
      company: "owner: of mazaq cloud kitchen",
      qualityCode: "\u2b50\u2b50\u2b50\u2b50\u2b50",
      ownerReview:
        "A professional team that delivers top-quality services across all fields. Outstanding experience.",
      image: mazaaq,
    },
    {
      id: 5,
      name: "Hind El-Husseini",
      company: "Owner: h2 group",
      qualityCode: "\u2b50\u2b50\u2b50\u2b50\u2b50",
      ownerReview:
        "Amazing work, the team delivered exactly what I needed with excellent communication.",
      image: hind,
    },
  ];

  return (
    <div className="relative py-16" id="clientsReviews">
      {/* Title and Underline */}
      <div className="mb-10 ml-6">
        <h3 className="font-semibold md:text-6xl text-4xl gradiantText relative ml-4">
          Clients Reviews
        </h3>
        <hr className="border-t-2 border-[var(--secondryColor)] w-full "></hr>
      </div>

      {/* Swiper Slider */}
      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        spaceBetween={30}
        slidesPerView={1}
        breakpoints={{
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 4,
          },
        }}
        className="mySwiper"
      >
        {reviews.map((review) => (
          <SwiperSlide key={review.id}>
            <div
              className="relative w-[300px] h-[400px] bg-gradient-to-r from-blue-700 via-indigo-800 to-blue-900 shadow-lg rounded-[20px] p-6 mx-auto"
              style={{ overflow: "hidden" }}
            >
              <div className="relative w-[150px] h-[150px] overflow-hidden rounded-full border-2 border-white mx-auto">
                <img
                  src={review.image}
                  alt={review.name || "Anonymous"}
                  className="w-full h-full object-cover"
                  style={{ objectPosition: "center" }}
                />
              </div>
              {/* Main Card Content */}
              <div className="mt-4 text-center">
                <h3 className="text-xl font-semibold text-white" style={{ wordWrap: "break-word" }}>
                  {review.name || "Anonymous"}
                </h3>
                <p className="text-sm text-gray-300 mt-1">
                  {review.id === 2 ? "OWNER OF SOUQ SAMAK PORTSAID RESTAURANT" : ` ${review.company}`}
                </p>
                <p
                  className="mt-2"
                  style={{
                    background: "linear-gradient(to right, red, purple, white)",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  {review.qualityCode}
                </p>

                <p className="mt-4 text-gray-200" style={{ overflow: "hidden", textOverflow: "ellipsis", maxHeight: "100px" }}>
                  {review.ownerReview}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Buttons */}
      <div className="swiper-button-prev" style={{ color: "#7579ff", left: "20px" }}></div>
      <div className="swiper-button-next" style={{ color: "#7579ff", right: "20px" }}></div>

      {/* Hide Navigation Buttons on Small Screens */}
      <style>{`
        @media (max-width: 768px) {
          .swiper-button-prev,
          .swiper-button-next {
            display: none;
          }
        }
      `}</style>
    </div>
  );
}